import {
    BaseCollectionModel,
    SearchModel,
    yascCreateEntityApiRoutesV3,
    YascEntityApiAdapterV3,
    YascEntityApiRoutesV3
} from '@yasc/yasc-material-components';
import {
    LicenseDataMinRes,
    LicenseDataRequest,
    LicenseDataResponse,
    LicenseDataUReq
} from '../../../../contracts/v0/contracting/license-data.contracts';
import {Observable} from "rxjs";
import {ApiV0Contracting} from '../api.v0.contracting';
import {RestApiService} from '../../../rest-api.service';

export class ApiV0LicenseDataV3 implements YascEntityApiAdapterV3<LicenseDataMinRes, LicenseDataResponse, LicenseDataRequest, LicenseDataUReq> {
    modelTypes = {
        row: LicenseDataMinRes,
        detail: LicenseDataResponse,
        create: LicenseDataRequest,
        update: LicenseDataUReq,
    }
    readonly idKey = 'guid' as const;
    readonly segment: string;
    readonly routes: YascEntityApiRoutesV3<string>

    constructor(v0: ApiV0Contracting, private readonly rest: RestApiService) {
        this.segment = v0.segment + '/licenseData'
        this.routes = yascCreateEntityApiRoutesV3(this.segment);
    }

    search(search?: SearchModel): Observable<BaseCollectionModel<LicenseDataMinRes, undefined, undefined>> {
        return this.rest.post<SearchModel, BaseCollectionModel<LicenseDataResponse>>(this.routes.search, LicenseDataResponse, search)
    }

    detail(id: string): Observable<LicenseDataResponse> {
        return this.rest.get(`${this.segment}/${id}`, LicenseDataResponse)
    }

    create(request: LicenseDataRequest): Observable<LicenseDataResponse> {
        return this.rest.post<LicenseDataRequest, LicenseDataResponse>(this.segment, LicenseDataResponse, request)
    }

    patch(id: string, request: LicenseDataUReq): Observable<LicenseDataResponse> {
        return this.rest.patch<LicenseDataRequest, LicenseDataResponse>(this.segment + `/${id}`, LicenseDataResponse, request)
    }

    delete(ids: string[]): Observable<void> {
        return this.rest.delete<void>(this.segment, Object as any, ids);
    }
}